export default __webpack_public_path__ + "ef8de3bc6f6a94d755dfff999abdfcc2.svg";